module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAAPRJREFUeF7t2EEKgzAUANF4/0O3SxFKQh1cGF73kXZ4+ZZ/DJ9pgUOfeQGBFkIEEqgNEYIIIqgVIKj1M4MIIqgVIKj1M4MIek7Qpz36dad/3qbZFRNojCHQCf1vQa+7I098YW8xb7HmiiCCCGoFCGr9zCCCCGoFCGr9zCCCCGoFCGr97IPCPshG0Ubxcv1sFO9MI/+DvMXuuFlM7vbIvU67Yq5YE00QQQS1AgS1fmYQQQS1AgS1fmZQEGRhZmHWFmYELQS16bbJaUM6DOlNDLSfQRBBBLUCBLV+ZhBBBLUCBLV+ZhBBBLUCBLV+ZhBBBLUCi9NfEN8JSaGISIIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_caidan@3x.png
// module id = bVG0
// module chunks = 1